import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMergeRooms = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3,3 H15 V9 H21 V21 H9 V15 H3 Z",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9,15 V9 H15 V15 Z",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.3px",
			strokeLinejoin: "round",
			strokeDasharray: "1.8,1.8"
		}
	})]
});
export default SvgMergeRooms;
